
import { defineComponent, onMounted, ref } from "vue";
import BackButton from "../components/BackButton.vue";
import User from "../interfaces/User/User.interface";
import { store } from "../store";
import GETRoom from "../interfaces/Room/GETRoom.interface";
import GETSection from "../interfaces/Section/GETSection.interface";
export default defineComponent({
  name: "Stats",
  components: { BackButton },
  setup() {
    const topRooms = ref([] as GETRoom[]);
    const topSections = ref([] as GETSection[]);
    const topUsers = ref([] as User[]);

    /**
     * Retrieves stats about top sections, rooms, and users
     */
    onMounted(async () => {
        const response = await Promise.all([store.dispatch("getTopUsers"), store.dispatch("getTopRooms"), store.dispatch("getTopSections")]);
        if (response[0] !== null) {
            topUsers.value = response[0];
        }
        if (response[1] !== null) {
            topRooms.value = response[1];
        }
        if (response[2] !== null) {
            topSections.value = response[2];
        }
    });

    return {
      topRooms,
      topSections,
      topUsers,
    };
  },
});
